import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M3.846 16.24c0-4.669 3.626-8.454 8.099-8.454 3.026 0 5.665 1.733 7.055 4.3M11.746 4v1.608"
    />
    <path
      fill="currentColor"
      d="M5.652 5.07a.57.57 0 0 0-.83 0 .63.63 0 0 0 0 .867l.415-.433zm.26 2.004c.228.24.6.24.83 0a.63.63 0 0 0 0-.866l-.416.433zm-.675-1.57-.415.433 1.09 1.137.414-.433.415-.433L5.652 5.07zM2.703 9.176a.585.585 0 0 0-.727.42.616.616 0 0 0 .429.742l.149-.58zm1.19 1.579c.319.089.644-.099.727-.42a.616.616 0 0 0-.43-.743l-.148.581zm-1.339-.998-.15.581 1.489.417.149-.582.149-.58-1.488-.417zM21.184 9.28c.319-.09.644.098.727.42a.616.616 0 0 1-.43.742l-.148-.581zm-1.19 1.578a.585.585 0 0 1-.727-.42.616.616 0 0 1 .429-.742l.149.581zm1.339-.997.149.581-1.488.416-.149-.58-.15-.582 1.489-.416zM18.234 5.07c.229-.238.6-.238.83 0 .229.24.229.628 0 .867l-.415-.433zm-.26 2.004a.57.57 0 0 1-.83 0 .63.63 0 0 1 0-.866l.416.433zm.675-1.57.415.433-1.09 1.137-.415-.433-.415-.433 1.09-1.137z"
    />
    <path
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M3.672 18.641c.763-.548 2.302-2.258 4.365-.644 2.3 1.799 5.317 1.566 6.805.571m0 0c.769-.513 1.13-1.23.774-1.974-.725-1.519-3.438.14-.774 1.974Zm0 0c.297.204.66.41 1.1.615 3.513 1.633 4.064-1.726 3.9-3.61"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const SunIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
